import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { cn } from "../../lib/utils";
import { lockDocumentScroll } from "./document-scroll-lock";

const DialogContainer = createContext<HTMLDialogElement | null>(null);
export function useDialogContainer() { return useContext(DialogContainer); }

export function Dialog({ title, pending, onClose, children, className, variant = "modal" }: Readonly<{ title: string; pending: boolean; onClose: () => void; children: ReactNode; className?: string; variant?: "modal" | "drawer" }>) {
  const [element, setElement] = useState<HTMLDialogElement | null>(null);
  useEffect(() => {
    if (!element) return;
    const previous = document.activeElement;
    element.showModal();
    const unlockScroll = lockDocumentScroll();
    return () => { element.close(); unlockScroll(); if (previous instanceof HTMLElement) previous.focus(); };
  }, [element]);
  return <dialog ref={setElement} aria-label={title} aria-busy={pending} className={cn("border-0 backdrop:bg-zinc-950/50", variant === "drawer" ? "channel-editor" : "secret-modal !m-auto !max-h-[calc(100dvh_-_36px)] !w-[calc(100%_-_36px)] !max-w-md !overflow-y-auto", className)}
    onCancel={(event) => { event.preventDefault(); if (!pending) onClose(); }}
    onClick={(event) => {
      if (event.target !== event.currentTarget || pending) return;
      const bounds = event.currentTarget.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) onClose();
    }}>
    <DialogContainer.Provider value={element}><fieldset disabled={pending} className={cn("m-0 min-w-0 border-0 p-0", variant === "drawer" && "h-full min-h-0")}>{children}</fieldset></DialogContainer.Provider>
  </dialog>;
}
